import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AuthService } from '@auth0/auth0-angular';
import { Observable, distinctUntilChanged, filter, switchMap, take } from 'rxjs';
import { environment } from 'src/environments/environment';

import { UserService } from '@services/user.service';

@Injectable({ providedIn: 'root' })
export class BkAuthHttpInterceptor implements HttpInterceptor {
  private auth0Service = inject(AuthService);
  private route = inject(ActivatedRoute);
  private userService = inject(UserService);

  private tokenWithCustomerId = false;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const customerId = this.route.firstChild?.snapshot.params['customerId'];

    const token$ = this.auth0Service.getAccessTokenSilently({
      authorizationParams: {
        customerId: customerId,
      },
      cacheMode: this.tokenWithCustomerId ? 'on' : 'off', // Igore cache until we have successfully fetched a token with customerId
    });

    const reqWithToken$ = token$.pipe(
      switchMap((token) => {
        if (environment.debug) {
          //   console.log('Auth interceptor:', [req.url, parseJwt(token)]);
        }
        if (customerId) this.tokenWithCustomerId = true;

        const headers = req.headers
          .append('Authorization', `Bearer ${token}`)
          .append('Ocp-Apim-Subscription-Key', environment.subscriptionKey);
        const authReq = req.clone({ headers });
        return next.handle(authReq);
      }),
    );

    // If the request is for the user, let it through
    // If not, wait for the user to be loaded and for the router to have navigated to a customerId before proceeding
    const userLoaded$ = this.userService.userLoaded$.pipe(
      distinctUntilChanged(),
      filter((userLoaded) => (userLoaded && customerId) || req.url.includes('user')),
      take(1),
    );

    return userLoaded$.pipe(switchMap(() => reqWithToken$));
  }
}
